import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateRatePlan } from 'modules/settings/api';

export const useMutationUpdateRatePlan = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateRatePlan, {
    onSuccess: response => {
      successToast(t('ratePlanSuccessfullyEdited'));
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_RATE_PLANS);
    },
    onError: () => {
      errorToast();
    },
  });
};
